import $ from 'jquery';
$(function() {
    var o = $(".js-top-slide-wrapper")
        , a = $(".js-top-dots")
        , e = $(".js-top-arrow-left")
        , r = $(".js-top-arrow-right")
        , s = $()
        , d = o.length
        , u = 0;
    $(window).on("load", function() {
        o.css("visibility", "visible")
    });
    function l() {
        return setInterval(function() {
            t(u + 1)
        }, 5000)
    }
    for (var c = l(), t = function(e) {
        var r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : "FORWARD";
        if (!(o.length <= 1)) {
            var a, t = u;
            a = e,
                u = (a %= d) < 0 ? d + a : a;
            var i = o.eq(t)
                , n = o.eq(u);
            s.removeClass("page-main__slider-dot--active"),
                s.eq(u).addClass("page-main__slider-dot--active"),
                i.addClass("page-main__slide-wrapper--previous"),
                n.addClass("page-main__slide-wrapper--enter"),
            "FORWARD" === r && n.addClass("page-main__slide-wrapper--forward"),
            "BACKWARD" === r && n.addClass("page-main__slide-wrapper--backward"),
                o.each(function(e, r) {
                    var a = $(r);
                    e !== t && a.removeClass("page-main__slide-wrapper--previous"),
                    e !== u && a.removeClass("page-main__slide-wrapper--enter"),
                    e !== u && a.removeClass("page-main__slide-wrapper--forward"),
                    e !== u && a.removeClass("page-main__slide-wrapper--backward")
                }),
                clearInterval(c),
                c = l()
        }
    }, i = function(e) {
        var r = $("<div/>", {
            class: "page-main__slider-dot"
        });
        r.click(function() {
            return t(e)
        }),
            a.append(r)
    }, n = 0; n < d; n++)
        i(n);
    (s = a.find(".page-main__slider-dot")).eq(0).addClass("page-main__slider-dot--active"),
        e.click(function() {
            return t(u - 1, "BACKWARD")
        }),
        r.click(function() {
            return t(u + 1)
        });
    !function() {
        try {
            document.createEvent("TouchEvent")
        } catch (e) {
            return
        }
    }();
    var p, f = 0;
    o.on("touchstart", function(e) {
        f = e.touches[0].pageX
    }),
        o.on("touchmove", function(e) {
            return p = e
        }),
        o.on("touchend", function() {
            if (p) {
                var e = p.touches[0].pageX - f;
                30 < Math.abs(e) && t(u + (e < 0 ? 1 : -1), e < 0 ? "BACKWARD" : "FORWARD"),
                    p = void 0
            }
        });
});
